var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 15V16.6667H7.5V15H0.833333C0.3731 15 0 14.6269 0 14.1667V0.833333C0 0.3731 0.3731 0 0.833333 0H5.83333C6.82892 0 7.72258 0.436458 8.33333 1.12848C8.94408 0.436458 9.83775 0 10.8333 0H15.8333C16.2936 0 16.6667 0.3731 16.6667 0.833333V14.1667C16.6667 14.6269 16.2936 15 15.8333 15H9.16667ZM15 13.3333V1.66667H10.8333C9.91283 1.66667 9.16667 2.41286 9.16667 3.33333V13.3333H15ZM7.5 13.3333V3.33333C7.5 2.41286 6.75383 1.66667 5.83333 1.66667H1.66667V13.3333H7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.64008d591bc55cfeebb10218df2b26be.svg";
export { ForwardRef as ReactComponent };